import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../features/permission/redux/actions';
import ParentContentCard from '../common/ParentContentCard';
import showAlert from '../../common/utils/alert';
import { drapcodeIcon } from '../../common/custom/icon-library';
import ToggleButton from '../../common/ui/ToggleButton';
import EmbeddedPageFrame from '../common/ui/EmbeddedPageFrame';
import { PERMISSION_TYPES } from 'drapcode-constant';

export class DefaultPage extends Component {
  static propTypes = {
    permission: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    allowedFlags: [],
    activeTab: 'Delete Permissions',
    allSelected: false,
  };

  async componentDidMount() {
    const { projectId, version } = this.props.match.params;
    const { actions } = this.props;
    actions.loadProjectDetail({ projectId, version });
    await actions.getFlags({ projectId, version });
    const { permissionFlags } = this.props.permission;
    if (permissionFlags && permissionFlags.length > 0) {
      this.setState({ allowedFlags: permissionFlags });
      if (permissionFlags.length === PERMISSION_TYPES.length) {
        this.setState({ allSelected: true });
      }
    }
  }

  handleUpdatePermissions = () => {
    const { actions } = this.props;
    const { allowedFlags } = this.state;
    const { projectId } = this.props.match.params;
    const preConfirm = () => {
      actions.deletePermission({ allowedFlags, projectId });
    };
    showAlert(
      `Do you want to proceed with updating the permissions?`,
      preConfirm,
      `Yes`,
      'warning',
      '#d30b0b',
      '#757f91',
      'No',
    );
  };
  toggleFlag = (key) => {
    this.setState((prevState) => {
      const alreadySelected = prevState.allowedFlags.includes(key);
      const updatedFlags = alreadySelected
        ? prevState.allowedFlags.filter((f) => f !== key)
        : [...prevState.allowedFlags, key];
      const allKeys = PERMISSION_TYPES.map((item) => item.key);
      const allSelected = allKeys.every((k) => updatedFlags.includes(k));
      return {
        allowedFlags: updatedFlags,
        allSelected,
      };
    });
  };
  handleToggleAll = () => {
    const { allSelected } = this.state;
    if (allSelected) {
      showAlert(
        `Do you want to disable all delete permissions?`,
        () => {
          this.setState({
            allowedFlags: [],
            allSelected: false,
          });
        },
        `Yes`,
        'warning',
        '#d30b0b',
        '#757f91',
        'No',
      );
    } else {
      showAlert(
        `Do you want to enable all delete permissions?`,
        () => {
          const allFlags = PERMISSION_TYPES.map((item) => item.key);
          this.setState({
            allowedFlags: allFlags,
            allSelected: true,
          });
        },
        `Yes`,
        'warning',
        '#d30b0b',
        '#757f91',
        'No',
      );
    }
  };

  render() {
    const { allowedFlags, activeTab, allSelected } = this.state;
    const { projectDetail } = this.props.permission;
    if (!projectDetail) return '';

    const permissionCard = (
      <ParentContentCard
        title="Delete Permissions"
        icon="constants"
        CtaComponent={
          <ToggleButton
            className="ml-5"
            name="toggleAllPermissions"
            onChange={this.handleToggleAll}
            isChecked={allSelected}
            text={
              allSelected
                ? 'All Enabled'
                : allowedFlags.length === 0
                ? 'All Disabled'
                : 'Partially Enabled'
            }
          />
        }
      >
        <div className="row">
          {PERMISSION_TYPES &&
            PERMISSION_TYPES.map((item) => (
              <div className="col-md-4 mt-0" key={item.key}>
                <div className="card mt-1">
                  <div className="card-body" style={{ padding: '5px 15px' }}>
                    <div className="d-flex justify-content-between align-items-center">
                      <span style={{ fontWeight: 'bold' }}>{item.label}</span>
                      <div className="mt-3">
                        <ToggleButton
                          name={item.key}
                          onChange={() => this.toggleFlag(item.key)}
                          isChecked={allowedFlags.includes(item.key)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </div>
        <div className="row mt-3">
          <div className="col-md-8"></div>
          <div className="col-md-4 text-right">
            <button className="btn btn-theme-submit btn-md" onClick={this.handleUpdatePermissions}>
              <i className={`wb ${drapcodeIcon('save')}`}></i>&nbsp;Update Permissions&nbsp;
            </button>
          </div>
        </div>
      </ParentContentCard>
    );

    return (
      <EmbeddedPageFrame embedded={this.props.embedded} containerClassName="deletePermission">
        {permissionCard}
      </EmbeddedPageFrame>
    );
  }
}

function mapStateToProps(state) {
  return {
    permission: state.permission,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DefaultPage);
